import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import footerStyles from "../../styles/footer.module.scss";
import fallbackData from "../../json/globalContent.json";
import { customerServiceNumberFormatted } from '../../utility/utils/formatter';

const Footer = () => {
  const [err, setErr] = useState(null);
  const baseUrl = process.env.REACT_APP_CMS_URL;
  const globalContentData = useSelector(store => store.globalContent.data) || fallbackData;

  const [footerMenu, setFooterMenu] = useState(globalContentData?.footer_menu ? globalContentData.footer_menu.slice(0, 4) : null);
  
  useEffect(() => {
    if (window.innerWidth < 600 || window.innerWidth === 767) {

      const headers = document.querySelectorAll(`.footer-accord`);
      const handler = (e) => {
        const header = e.currentTarget;
        header.classList.toggle("active");
        const panel = header.nextElementSibling;
        if (!panel) return;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = `${panel.scrollHeight}px`;
        }
      };
      headers.forEach((h) => h.addEventListener("click", handler));
      return () => headers.forEach((h) => h.removeEventListener("click", handler));
    }
  }, [globalContentData]);

  const renderFooterSections = (menu) => {
    if (menu.below || menu.below.length > 0) {
      return menu.below.map((item) => {
        let url = item.url;
        if (
          !(
            (item.title && item.title.toLowerCase() === "careers") ||
            url.includes("http") ||
            url.includes("www")
          )
        ) {
          url = `${baseUrl}${item.url}`;
        }
        return (
          <li key={item.title}>
            <a href={url}>{item.title}</a>
          </li>
        );
      });
    } else {
      return null;
    }
  };

  useEffect(() => {
    if(globalContentData && globalContentData?.footer_menu)
      setFooterMenu(globalContentData.footer_menu.slice(0, 4));

  }, [globalContentData])

  if (!footerMenu || err) return null;

  return (
    <footer className={`${footerStyles["footer-panel"]} tg-footer`}>
      <div className="container">
        <div className="row">
          {footerMenu.map((menu) => (
            <div className={footerStyles["nav-list"]} key={menu.title}>
              <div className={footerStyles["mob-border"]}>
                <h5 className={`${footerStyles["accordion_footer"]} footer-accord`}>{menu.title}</h5>
                <ul
                  className={`${footerStyles["panel"]} ${footerStyles["list-unstyled"]}`}
                >
                  {renderFooterSections(menu)}
                </ul>
              </div>
            </div>
          ))}
          <div className={footerStyles["nav-list"]}>
            <div className={footerStyles["mob-border"]}>
              <h5 className={`${footerStyles["accordion_footer"]} footer-accord`}>GET SUPPORT</h5>
              <ul
                className={`${footerStyles["panel"]} ${footerStyles["list-unstyled"]}`}
              >
                <li>
                  <a href={`${baseUrl}/contact-us`}>Contact Us</a>
                </li>
                <li>
                  <a href={`tel:${customerServiceNumberFormatted}`}>{customerServiceNumberFormatted}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row">
          <div className={footerStyles["terms-condition"]}>
            <p>
              America’s #1 lawn care company based on U.S. market share of
              professional lawn care companies. 2021 MMR Brand Health Tracker.{" "}
              <a href="http://pgatour.com/" className={footerStyles["greentext"]}>
                PGATOUR.COM,
              </a>
              PGA TOUR, TPC, SHOTLINK and the SWINGING GOLFER LOGO are
              trademarks of PGA TOUR, Inc. BBB accredited since 7/01/2012.
            </p>
          </div>
        </div>

        <div className={footerStyles["social-panel"]}>
          <div className="row">
            <div className="col-md-6">
              <a href="https://www.facebook.com/trugreen">
                <img src="/images/footer/fb.png" />
              </a>
              <a href="https://x.com/trugreen">
                <img src="/images/footer/social2.png" />
              </a>
              <a href="https://www.instagram.com/trugreen_lawn/">
                <img src="/images/footer/ints.png" />
              </a>
              <a href="https://www.youtube.com/trugreen">
                <img src="/images/footer/yt.png" />
              </a>
              <a href="https://www.tiktok.com/@trugreen_lawn">
                <img src="/images/footer/tiktok.png" />
              </a>
              <a href="https://www.yelp.com/">
                <img src="/images/footer/social.png" />
              </a>
            </div>
            <div className="col-md-6">
              <div className={footerStyles["brand-icon"]}>
                <a href="https://www.bbb.org/us/tn/memphis/profile/lawn-maintenance/trugreen-0543-1000545">
                  <img src="/images/footer/bbb 1.png" className="img-fluid" />
                </a>
                <a href="javascript:void(0);">
                  <img src="/images/footer/NALP.png" className="img-fluid" />
                </a>
                <a href="https://www.trugreen.com/pga-tour">
                  <img src="/images/footer/TG_Lock_K 1.png" className="img-fluid" />
                </a>
                <a href="javascript:void(0);">
                  <img src="/images/footer/Group.png" className="img-fluid" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <hr></hr>
        <div className={footerStyles["last-section"]}>
          <div className="row f-row">
            <div className="col-md-5">
              <p>
                <img src="/images/footer/tg-mark-black.png" />© {new Date().getFullYear()} TruGreen
                Limited Partnership. All rights reserved.
              </p>
            </div>
            <div className="col-md-7">
              <ul>
                <li>
                  <a href={`${process.env.REACT_APP_RESI_URL}/about/terms`}>
                    Terms and Conditions
                  </a>
                </li>
                <li>
                  <a href={`${process.env.REACT_APP_RESI_URL}/about/privacy-policy`}>
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href={`${process.env.REACT_APP_RESI_URL}/about/california-privacy-policy`}>
                    California Privacy Notice
                  </a>
                </li>
                <li>
                  <a href={`${process.env.REACT_APP_RESI_URL}/about/privacy-policy`}>
                    Your Privacy choices
                    <img src="/images/footer/privacyoptions1.svg" className="privacy-choice" alt="Privacy Options" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
